import React from "react"
import styled from "@emotion/styled"
import ButtonLink from "../global/ButtonLink"

const Outer = styled.section`
  display: grid;
  grid-template-columns:
    minmax(32px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(32px, auto);
  padding: 160px 0;
  background: ${props =>
    props.backgroundColorOverride
      ? props.backgroundColorOverride
      : "transparent"};
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 24px auto 24px;
  }
`
const Inner = styled.div`
  grid-column: 2;
  text-align: center;
  display: grid;
  gap: 64px;
`
const CTAtext = styled.div`
  display: grid;
  gap: 32px;
  max-width: 640px;
  margin: 0 auto;
  p {
    margin: 0 auto;
    max-width: 480px;
  }
`

const ButtonContainer = styled.div`
  margin: 0 auto;
`
const Title = styled.h2``

export default function CTABlock({
  postContent,
  backgroundColorOverride,
  buttonText,
  buttonLink,
  title,
}) {
  return (
    <Outer backgroundColorOverride={backgroundColorOverride}>
      <Inner>
        <div>
          {title && <Title>{title}</Title>}
          <CTAtext>
            {postContent && <p>{postContent}</p>}
            <ButtonContainer>
              <ButtonLink
                to={buttonLink}
                backgroundColorOverride={props => props.theme.primary}
              >
                {buttonText}
              </ButtonLink>
            </ButtonContainer>
          </CTAtext>
        </div>
      </Inner>
    </Outer>
  )
}
